var render = function render(_c,_vm){return _c('a',_vm._g({class:[_vm.data.class, _vm.data.staticClass],attrs:{"href":`tel:${_vm.props.number}`}},_vm.listeners),[(!_vm.children)?[_vm._v(" "+_vm._s(_vm.props.number)+" ")]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }